import { FC } from 'react';
import { twJoin } from '@utils/twMerge';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';

type SectionProps = {
  title?: string;
  path?: string;
  icon?: FC<{ className?: string }>;
  active?: boolean;
  disabled?: boolean;
  sideBarCollapsed?: boolean;
};

export const SectionTab: FC<SectionProps> = ({
  icon: Icon,
  title,
  path,
  active,
  disabled,
  sideBarCollapsed,
}) => {
  const titleClassName = twJoin(
    'text-1624 font-medium',
    active ? 'text-chineseBlack' : 'text-dimGray',
    disabled && 'opacity-30'
  );
  const content = (
    <div className='flex'>
      <div className='mr-2'>
        {Icon && (
          <Icon className={twJoin('h-3 w-3', active ? 'text-black' : '')} />
        )}
      </div>
      {title && !sideBarCollapsed && (
        <div className={titleClassName}>{title}</div>
      )}
    </div>
  );
  return (
    <Tooltip title={title} mouseEnterDelay={0.5}>
      {path && !disabled ? (
        <Link to={path} className='flex w-full'>
          {content}
        </Link>
      ) : (
        content
      )}
    </Tooltip>
  );
};
